import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import Reliability from './ReliabilityScore'

import { SpeakingRole } from '@db8/shared'

export const EvidenceCard = ({ evidence, selectedTab, setSelectedEvidence }) => {
  return (
    <div
      onClick={() => setSelectedEvidence(evidence)}
      className={`cursor-pointer bg-accent p-4 rounded-lg shadow hover:shadow-lg transition relative flex flex-col border h-[180px] sm:h-[160px] w-full min-w-[250px] max-w-[300px] ${
        selectedTab === SpeakingRole.Affirmative ? 'border-green-500' : 'border-blue-500'
      }`}
    >
      {/* Title & Link */}
      <div className="mb-2">
        <h4 className="font-bold text-base sm:text-lg leading-tight">{evidence.title}</h4>
        {evidence.link && (
          <a
            href={evidence.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 text-sm"
            onClick={(e) => e.stopPropagation()}
          >
            View Source
          </a>
        )}
      </div>

      {/* Summary with Tooltip */}
      <Tooltip>
        <TooltipTrigger asChild>
          <p className="text-sm flex-1 line-clamp-3 text-left">{evidence.summary}</p>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{evidence.summary}</TooltipContent>
      </Tooltip>

      {/* Reliability Score */}
      {/* {evidence.link && (
        <div className="flex justify-end mt-auto pt-2">
          <Reliability score={evidence.reliability} />
        </div>
      )} */}
    </div>
  )
}
